import { Input } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { useMissingCompanyDetailsForm } from '../../../../../../contexts/missingCompanyDetailsFormContext'

export const CompanyIban = (): ReactElement => {
  const { t } = useTranslation()
  const {
    missingCompanyDetailsForm: { FormItem },
  } = useMissingCompanyDetailsForm()

  return (
    <FormItem
      label={t('external_invoices.missing_company_compliance_details.modal.form.field.iban.label')}
      name="iban"
      render={({ field }) => {
        return <Input {...field} size="sm" />
      }}
    />
  )
}
